const log = {
    invalid_type: 'نوع السجل غير صالح.',
    invalid_time_window: 'يجب أن يكون `end_time` بعد `start_time`.',
};
export default Object.freeze(log);
